import localStorage from 'local-storage';

const LAST_ACTIVE_TEAM = 'last_accessed_team';

export const remove = () => localStorage.remove(LAST_ACTIVE_TEAM);

export const get = () => localStorage.get(LAST_ACTIVE_TEAM) || null;

export const set = (value) => localStorage.set(LAST_ACTIVE_TEAM, value);
